import React, { useMemo, useEffect } from 'react';

import { Section, Stack, Help } from '@gogame/components';
import { withForm, FormField, SidePageV2 } from '@gogame/form';

import {
  BUSINESS_PARTNER,
  APP_ID,
  POSTBACK_AND_CONVERSIONS_STATUSES,
} from 'scenes/PlayersActivities/PlayersInformation/constants';
import { downloadTemplateSchema } from 'scenes/PlayersActivities/PlayersInformation/schemas/downloadTemplateSchema';
import {
  loadBusinessPartners,
  loadApplications,
} from 'scenes/PlayersActivities/PlayersInformation/sources/fields';

const DownloadTemplateForm = withForm({
  enableReinitialize: true,
  validationSchema: downloadTemplateSchema,
})(({ onClose, onExited, open, values, setFieldValue, loading }) => {
  const isShowBusinessPartner = useMemo(
    () => !!values[POSTBACK_AND_CONVERSIONS_STATUSES],
    [values[POSTBACK_AND_CONVERSIONS_STATUSES]]
  );

  useEffect(() => {
    if (
      !values[POSTBACK_AND_CONVERSIONS_STATUSES] &&
      values[BUSINESS_PARTNER] !== undefined
    ) {
      setFieldValue(BUSINESS_PARTNER, undefined);
    }
  }, [
    setFieldValue,
    values[BUSINESS_PARTNER],
    values[POSTBACK_AND_CONVERSIONS_STATUSES],
  ]);

  return (
    <SidePageV2
      onClose={onClose}
      onExited={onExited}
      open={open}
      loading={loading}
      size={'sm'}
    >
      <SidePageV2.Title title={'Export Bulk Template'} />
      <SidePageV2.NewBody scroll={false}>
        <Section title={'Template Settings'}>
          <Stack spacing={3}>
            <FormField.Select
              name={APP_ID}
              label={'Application *'}
              source={loadApplications}
              padding={'0'}
            />
            <FormField.Checkbox
              name={POSTBACK_AND_CONVERSIONS_STATUSES}
              placeholder={'All'}
              label={
                <Stack
                  as={'span'}
                  spacing={0.5}
                  direction={'row'}
                  alignItems={'center'}
                >
                  <span> Postback and Conversions statuses</span>
                  <Help>
                    Shows "No" if event was completed more than 60 days ago.
                  </Help>
                </Stack>
              }
              padding={'0'}
            />
            {isShowBusinessPartner ? (
              <FormField.Select
                name={BUSINESS_PARTNER}
                source={loadBusinessPartners}
                label={'Business partner *'}
                placeholder={'Select business partner'}
                padding={'0'}
              />
            ) : null}
          </Stack>
        </Section>
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton>Export</SidePageV2.SubmitButton>
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default DownloadTemplateForm;
